export class GameInfo {
    readonly #gameVersion = "22.2";
    readonly #debug = "true";
    readonly #stage = "production";
    readonly #serverStage = "production";
    readonly #serverUrl = "https://caviar.cityversetycoon.com/";
    readonly #buildNumber = "99";

    public get gameVersion(): string {
        return this.#gameVersion;
    }

    public get debug(): boolean {
        return this.#debug.toLowerCase() === "true";
    }

    public get stage(): Stage {
        return this.#stage as Stage;
    }

    public get serverStage(): Stage {
        return this.#serverStage as Stage;
    }

    public get serverUrl(): string {
        return this.#serverUrl;
    }

    public get buildNumber(): string {
        return this.#buildNumber;
    }
}

export enum Stage {
    LOCALHOST = "localhost",
    STAGE = "stage",
    STAGING = "staging",
    PRODUCTION = "production",
    DEVELOPMENT = "development"
}